
import React, { Component } from "react";
import { Button, HStack, Spacer, VStack, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import _ from "lodash";

import CreatableSelect from "react-select/creatable";

import CoreService from "../../../../services/CoreService";
import LocalStorageService from "../../../../services/LocalStorageService";

import './css/Card.css';


Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

const createOption = (label) => ({
    label,
    value: label,
});

const components = {
    DropdownIndicator: null
};


export default class MultiEntryIQueueApiLookupInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            valid: true,
            inputValue: "",
            value: [],
            descript: "",
            apiLookupButtonEnabled: false,
            apiLookupButtonVisible: false,
            iQueueLookupButtonEnabled: false,
            iQueueLookupButtonVisible: false,
            inLookup: false,
            lookupError: false,
            lookupErrMsg: "",
            mraInfo: {}
        }

        this.coreService = new CoreService();
        this.localStorageService = new LocalStorageService();

        this.onApiLookupButtonClick = this.onApiLookupButtonClick.bind(this);
        this.onIQueueLookupButtonClick = this.onIQueueLookupButtonClick.bind(this);

    }


    componentDidMount() {
        if (this.props.valueBag[this.props.card.id]) {
            var val = this.props.valueBag[this.props.card.id];
            var newState = val.map((v) => { return createOption(v) });
            this.setState({ value: newState });
        }
    }


    handleChange = (value, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            let tagValue = actionMeta.removedValue.value;
            this.setState({ value: value });
        }
        else if (actionMeta.action === 'clear') {
            this.setState({ value: value });
        }
        var returnValue = [];
        if (value) {
            returnValue = value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(returnValue, this.props.card.id);

        if (this.props.card.lookupInfo?.inboundQueue?.mraEnabled)
        {
            var newMraInfo = this.props.valueBag["mraInfo"];
            newMraInfo.palletIds = returnValue;
            this.setState({mraInfo: newMraInfo});
            this.props.onValueChange(newMraInfo, 'mraInfo', false);
        }
    };

    handleInputChange = (inputValue) => {
        this.setState({ inputValue });
    };


    handleKeyDown = (event) => {
        if (!this.state.inputValue) return;
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                this.setValue(this.state.inputValue);
                this.setInputValue('');
                event.preventDefault();
        }
        var tempVal;
        if (this.state.value) {
            tempVal = this.state.value.map(v => {
                return v.value;
            });
        }
        this.props.onValueChange(tempVal);
    };

    setInputValue(val, actionMeta) {
        this.setState({ inputValue: val })
    }


    setValue(val) {
        console.log(typeof (val))
        var newValArray
        if (typeof (val) === "string") {
            var newVal = createOption(val)
            newValArray = this.state.value
            newValArray.push(newVal)
        } else {
            newValArray = val
        }
        this.setState({
            value: newValArray
        })

        // this is returning an array of key Option objects (label, value pairs)

        // this.props.onValueChange(this.state.value);
    }



    async onIQueueLookupButtonClick(e) 
    {
        this.setState({ lookupErrMsg: "", inLookup: true });
        try {
            var inboundQueueInfo = this.props.card.lookupInfo.inboundQueue;
            if (!inboundQueueInfo) 
            {
                this.setState({ lookupErrMsg: "No Inbound Queue Lookup Info available for this card" });
                return;
            }
            // lookup uses FIRST value
            var param1 = (Array.isArray(this.state.value) ? (this.state.value[0].value) ? this.state.value[0].value : "" : this.state.value);
            if (!param1) {
                var lbl = (apiInfo.paramLabel) ? apiInfo.paramLabel : "value";
                this.setState({ lookupErrMsg: "Please enter at least one " + lbl });
                return;
            }

            var receiptDetailLineDbResult = await this.coreService.fetchInboundQueueReceiptLineByKeyIdentifier(param1, this.props.schemaId, this.props.gcid, this.props.token);
            if (receiptDetailLineDbResult.hasError) {
                var errMsg = (receiptDetailLineDbResult.isRecordNotFound) ? param1 + " not found." : "Error fetching Inbound Queue Info.";
                this.setState({ lookupErrMsg: errMsg });
                return;
            }
            var receiptDetailLine = receiptDetailLineDbResult.dataResult;

            var openDetailKeysListResponse = await this.coreService.fetchInboundQueueDetailKeys(receiptDetailLine.header.schemaId, receiptDetailLine.header.receiptIdentifier, receiptDetailLine.detail.receiptDetailIdentifier, this.props.gcid, this.props.token);
            var detailKeys = openDetailKeysListResponse.dataResult;
            receiptDetailLine.detail.detailKeys = detailKeys;

            if (inboundQueueInfo.mraEnabled)
            {      
                var newMraInfo = {};     
                newMraInfo.receiptId = receiptDetailLine.header.data.TransactionId;
                newMraInfo.tagId = receiptDetailLine.header.data.TagId;
                newMraInfo.blockId = receiptDetailLine.detail.data.BlockId;
                newMraInfo.lineId = receiptDetailLine.detail.data.LineId;
                newMraInfo.palletIds = detailKeys;
                this.setState({mraInfo: newMraInfo});
                this.props.onValueChange(newMraInfo, 'mraInfo', false);
            }

            this.props.onValueChange(receiptDetailLine.detail.detailKeys, this.props.card.id);
            var v = detailKeys.map((dk) => { return createOption(dk) });
            this.setState({ value: v });
            // then we need to set the properties using the data list and the receipt and the line. 
            var propMapDataList = this.localStorageService.getDataList(inboundQueueInfo.PropMapDataListId, this.props.gcid);
            var propMap = propMapDataList.data.data;
            //var initialBag = {};
            propMap.forEach((p) => {
                // find the prop in the actual data 
                // header or detail? (why did I do it this way? I could have just had a "flat" structure!)
                var propMapSplit = p.name.split(".");
                var dataNode = (propMapSplit[0] === '[detail]') ? "detail" : "header";
                var dataField = propMapSplit[1];
                var val = receiptDetailLine[dataNode]["data"][dataField];
                if (!this.repressOverwrite(p.id, this.props.valueBag, this.props.card.lookupInfo.overwriteRules)) {
                    // we are NOT changing the current card here - only the mapped card
                    this.props.onValueChange(val, p.id, false);
                }
            });




        }
        finally {
            this.setState({ inLookup: false });
        }



    }

    async onApiLookupButtonClick(e) {
        this.setState({ lookupErrMsg: "", inLookup: true });
        try {
            var apiInfo = this.props.card.lookupInfo.api;
            if (!apiInfo) {
                this.setState({ lookupErrMsg: "No Api Lookup Info available for this card" });
                return;
            }
            // here is where we would use alternate info if we are not using the current user session info
            var auth = {};
            auth.gcid = this.props.gcid,
                auth.token = this.props.token;

            // lookup uses FIRST value
            var param1 = (Array.isArray(this.state.value) ? this.state.value[0].value : this.state.value);
            if (!param1) {
                var lbl = (apiInfo.paramLabel) ? apiInfo.paramLabel : "value";
                this.setState({ lookupErrMsg: "Please enter at least one " + lbl });
                return;
            }


            if (apiInfo.remoteApiInfo?.endpoints?.existsEndpoint) {
                var endpoint = apiInfo.remoteApiInfo?.endpoints?.existsEndpoint.replace("{param1}", param1);
                var existsResult = await this.coreService.fetchApiProxyUrl(apiInfo.remoteApiInfo?.proxyHost, endpoint, auth.gcid, auth.token);
                if (existsResult.hasError) {
                    this.setState({ lookupErrMsg: "There was an error checking if the " + apiInfo.paramLabel + " (" + param1 + ") exists." });
                    return;
                }
                if (existsResult.hasError && existsResult.isRecordNotFound) {
                    this.setState({ lookupErrMsg: "Could not find " + apiInfo.paramLabel + " " + param1 + " ." });
                    return;
                }
            }

            if (apiInfo.remoteApiInfo?.endpoints?.fetchEndpoint) {
                var endpoint = apiInfo.remoteApiInfo?.endpoints?.fetchEndpoint.replace("{param1}", param1);
                var fetchResult = await this.coreService.fetchApiProxyUrl(apiInfo.remoteApiInfo?.proxyHost, endpoint, auth.gcid, auth.token);
                if (fetchResult.hasError) {
                    this.setState({ lookupErrMsg: "There was an error fetching the " + apiInfo.resultType + " with value " + param1 + " ." });
                    return;
                }
                // The Api may return an object, but it may be "empty"
                var emptyProp = (this.props.card.lookupInfo.api.notFoundIfEmptyProp) ? this.props.card.lookupInfo.api.notFoundIfEmptyProp : null;
                if (emptyProp) {
                    var inboundProp = Object.byString(fetchResult.dataResult, emptyProp);
                    if (!inboundProp) {
                        this.setState({ lookupErrMsg: "Unable to find " + apiInfo.resultType + " with value " + param1 + " ." });
                        return;
                    }
                }

                this.mapParsedFields(fetchResult.dataResult);
            }
        } finally {
            this.setState({ inLookup: false });
        }
    }


    mapParsedFields(parsedObject) {
        var fieldMap = this.props.card.lookupInfo.api.fieldMap;
        for (var key in fieldMap) {
            let entityField = fieldMap[key];
            var val = Object.byString(parsedObject, entityField);
            if (val) {
                if (!this.repressOverwrite(key, this.props.valueBag, this.props.card.lookupInfo.overwriteRules)) {
                    // we are NOT changing the current card here - only the mapped card
                    this.props.onValueChange(val, key, false);
                }
            }
        }
    }


    repressOverwrite(key, valueBag, overwriteRules) {
        if (!overwriteRules) return false;
        if (overwriteRules.overwriteAllProps) return false;
        if (!overwriteRules.doNotOverwriteProps) return false;
        if (!Array.isArray(overwriteRules.doNotOverwriteProps)) return false;

        var hasDoNotOverwriteKey = overwriteRules.doNotOverwriteProps.includes(key);
        if (!hasDoNotOverwriteKey) return false;
        var doNotOverwriteKeyIsInValueBag = (key in valueBag);
        if (!doNotOverwriteKeyIsInValueBag) return false;
        if ((valueBag[key].trim() === "") || (valueBag[key] == null)) return false;
        return true;
    }


    render() {
        const { inputValue, value } = this.state;

        var showIQueueLookupButton = this.props.card.lookupInfo?.inboundQueue?.lookupEnabled;
        var iQueueLookupButtonLabel = (this.props.card.lookupInfo?.inboundQueue?.buttonLabel) ? this.props.card.lookupInfo.inboundQueue.buttonLabel : "Inbound Lookup";

        var showApiLookupButton = this.props.card.lookupInfo?.api?.lookupEnabled;
        var apiLookupButtonLabel = (this.props.card.lookupInfo?.api?.buttonLabel) ? this.props.card.lookupInfo.api.buttonLabel : "Api Lookup";

        return (
            <VStack width={"100%"}>
                <HStack width={"100%"}>


                    <CreatableSelect
                        autoFocus
                        components={components}
                        inputValue={inputValue}
                        // options={formattedOptions}
                        isClearable
                        isMulti
                        menuIsOpen={false}
                        // isDisabled={false}
                        onChange={this.handleChange}
                        onInputChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        placeholder="Type Tag and Press Enter"
                        value={this.state.value}

                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                minHeight: '40px',
                                minWidth: '-webkit-fill-available',
                                marginRight: '10px'
                            }),
                            valueContainer: (baseStyles, state) => ({
                                ...baseStyles,
                                fontSize: '16px',
                                marginBottom: '10px'
                            })
                        }}
                    />




                    {(this.state.inLookup) ? <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} /> : <span />}
                    <Spacer />
                    {showIQueueLookupButton &&
                        <Button
                            id="iqueue-button"
                            bg='#0095c8'
                            color='white'
                            variant="solid"
                            fontSize={{ base: '10px', md: '14px', lg: '16px' }}
                            disabled={!this.state.iQueueLookupButtonEnabled}
                            onClick={(e) => this.onIQueueLookupButtonClick(e)}
                            fontColor={(this.state.lookupError) ? "yellow" : "white"}

                        >

                            {iQueueLookupButtonLabel}


                        </Button>
                    }

                    {showApiLookupButton &&
                        <Button
                            id="api-button"
                            bg='#0095c8'
                            color='white'
                            variant="solid"
                            fontSize={{ base: '10px', md: '14px', lg: '16px' }}
                            disabled={!this.state.apiLookupButtonEnabled}
                            onClick={(e) => this.onApiLookupButtonClick(e)}
                            fontColor={(this.state.lookupError) ? "yellow" : "white"}

                        >
                            {apiLookupButtonLabel}
                        </Button>
                    }
                </HStack>
                <Text color={"yellow.100"}>
                    {this.state.lookupErrMsg}
                </Text>
            </VStack>
        );
    }
}







